var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-flex"},[_c('div',{staticClass:"c-avatar -medium"},[_c('img',{staticClass:"c-avatar__photo",attrs:{"src":_vm.item.avatar_url,"alt":_vm.item.displayname}})]),_c('div',{staticClass:"t-body3 u-marginLeft2"},[_vm._v(" "+_vm._s(_vm.item.displayname)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }